function setYear() {
  let currentYear = document.querySelector("#current-year");
  if (!currentYear) return;
  currentYear.innerHTML = new Date().getFullYear().toString();
}

function navToggle() {
  document.querySelectorAll("[data-nav-toggle]").forEach((button) => {
    const target = document.querySelector(button.getAttribute("aria-controls"));
    if (!target) return;

    button.addEventListener("click", () => {
      const expanded = button.getAttribute("aria-expanded") === "true";
      button.setAttribute("aria-expanded", String(!expanded));
      target.classList.toggle("hidden", expanded);
    });
  });
}

function playPauseVideo() {
  const videos = document.querySelectorAll("video");
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting && !entry.target.paused) {
          entry.target.pause();
        }
        if (entry.isIntersecting && entry.target.paused) {
          entry.target.play();
        }
      });
    },
    {
      threshold: 0,
    }
  );
  for (const video of videos) observer.observe(video);
}

document.addEventListener("DOMContentLoaded", () => {
  setYear();
  navToggle();

  let scrolled = false;
  document.addEventListener("scroll", (event) => {
    if (scrolled) {
      return;
    }
    scrolled = true;
    playPauseVideo();
    // setTimeout(() => {
    //   scrolled = false;
    // }, 1000);
  });
});
